import { updateLinkParams } from './updateLinkParams';

interface IFiledOptions {
	width: number;
	height?: number;
	isCropped?: boolean;
}

export const getFiledUrl = (srcFiled: string, { width, height, isCropped }: IFiledOptions ) => {
	const url = String(srcFiled);

	if (!url.includes('base64') && url.includes('filed')) {
		return updateLinkParams(
			srcFiled,
			{
				mw: width || undefined,
				mh: height || width || undefined,
				croped: isCropped ? 1 : undefined,
			},
		);
	}
	return url;
};
